import {
  AArrowDown,
  ChevronRight,
  Check,
  Plus,
  Info,
  ClipboardCopy,
  LogIn,
  ArrowLeft,
  ArrowUpRight,
  ArrowRight,
  CircleAlert,
  Lock,
  Route,
  PencilRuler,
  MessageSquareShare,
  Library,
  MonitorPlay,
  SmilePlus,
  BookOpen,
  ScreenShare,
  SlidersHorizontal,
  LogOut,
  BadgeQuestionMark,
  Upload,
  Pencil,
  X,
  Menu,
  KeyRound,
  Shield,
  Trash2,
  Users,
  Sparkle,
  Link2,
  SendHorizontal,
} from "lucide-react";

export const icons = {
  "a-arrow-down": AArrowDown,
  plus: Plus,
  "chevron-right": ChevronRight,
  check: Check,
  info: Info,
  "clipboard-copy": ClipboardCopy,
  "log-in": LogIn,
  "arrow-left": ArrowLeft,
  "arrow-up-right": ArrowUpRight,
  "arrow-right": ArrowRight,
  "circle-alert": CircleAlert,
  lock: Lock,
  route: Route,
  "pencil-ruler": PencilRuler,
  "message-square-share": MessageSquareShare,
  library: Library,
  "monitor-play": MonitorPlay,
  "smile-plus": SmilePlus,
  "book-open": BookOpen,
  "screen-share": ScreenShare,
  "sliders-horizontal": SlidersHorizontal,
  "log-out": LogOut,
  "badge-question-mark": BadgeQuestionMark,
  upload: Upload,
  pencil: Pencil,
  x: X,
  menu: Menu,
  key: KeyRound,
  shield: Shield,
  trash: Trash2,
  users: Users,
  sparkle: Sparkle,
  "link-2": Link2,
  "send-horizontal": SendHorizontal,
} as const;

export type IconName = keyof typeof icons;
